import { convertToRTS, createTS } from 'utils/timestamp'

/**
 * Dispatch event to data layer
 */
export function publishEvent (type, payload, timeFields = []) {
  const timestamp = createTS();
  // GTM note: intercom requires timestamps in format "dddd, MMMM Do YYYY, H:mm:ss"
  const intercomTimestamp = convertToRTS(timestamp);
  const intercomTimeFields = timeFields.reduce((props, propName) => {
    const newPropName = `intercom${propName[0].toUpperCase()}${propName.substr(1)}`;
    props[newPropName] = convertToRTS(payload[propName]);
    return props;
  }, {});
  dataLayer.push({
    event: 'logEvent',
    eventType: type,
    eventProperties: {
      ...payload,
      ...intercomTimeFields,
      timestamp,
      intercomTimestamp
    }
  })
  console.log("Published", type, JSON.stringify(payload))
}

export function sendClassApprovedEvents({userId, sessionId, programId, contractId, staffUserId, validUntil, noEmail, language}) {
  const payload = {
    userId,
    sessionId,
    programId,
    funding: "CONTRACT",
    contractId,
    staffUserId,
    validUntil,
    language
  };
  if (!noEmail) {
    publishEvent(`Class Approved Nurture Campaign Started`, payload, ['validUntil']);
  }
  publishEvent(`Class Approved`, payload, ['validUntil']);
}



// WEBPACK FOOTER //
// ./src/services/events.js